import actions from './_actions';
import mutations from './_mutations';
import state from './_state';
import types from './_types';

export default {
  actions,
  mutations,
  state,
  types
};



// WEBPACK FOOTER //
// ./src/stores/lang/index.js